import {Box, Button, Form, FormField, Heading, Layer, RadioButtonGroup, TextInput} from "grommet";
import { FINAX_CLIENT_TYPE } from "./SavingIzp";

const FinaxProductForm = ({onClose, onSubmit, values, setForm}) => {

	return (
		<Layer onEsc={() => onClose(false)} onClickOutside={() => onClose(false)} >
			<Box pad="medium">
				<Form
					value={values}
					onChange={nextValue => {					
						setForm(nextValue);
					}}
					onSubmit={({ value }) => onSubmit(value) }
				>
					<Heading level="3" margin={{top: "none"}}>Nastavenie parametrov</Heading>

					<Box direction={'row'} align={'center'} basis={'1/2'}>
						<FormField label="Vstupný poplatok (%)" width={'full'}>
							<TextInput name="fee" type="number" step="0.001" autoFocus required={true} />
						</FormField>
					</Box>

                    <Box direction={'row-responsive'}>
                        <Box basis={'auto'} round={'xsmall'} margin={{bottom: 'large', top:'medium'}}>
                            <FormField label="Typ klienta" width={'full'}>
                                <RadioButtonGroup direction={'column'} gap={'medium'} name="clientType" options={FINAX_CLIENT_TYPE.map(function(v){
                                    return {value: v.id, label: v.label}
                                })} />
                            </FormField>
                        </Box>
                    </Box>

					<Box direction="row" gap="medium" margin={{top:'large'}}>
						<Button type="submit" primary label="Pridať" />
						<Button onClick={() => onClose(false)} label="Zavrieť" />
					</Box>
				</Form>
			</Box>
		</Layer>
	)
}

export default FinaxProductForm;